import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core'
import MaterialTags from 'components/Common/ArticleSelector/MaterialTags'
import { MoneyString } from 'model/Money'
import { PartTypeRow } from 'model/Project/BoMItemRow'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { RootAppState } from 'store/configureStore'
import { TargetPriceGraphData } from '../../useBomItemDetails'
import { TargetPriceTooltipListItemText } from './TargetPriceTooltipListItemText'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: theme.spacing(2),
    },
  })
)

export const TotalTooltip = (props: { data: TargetPriceGraphData }) => {
  const cn = useStyles()
  const { t } = useTranslation()

  const { tokens, description } = useAppSelector((state: RootAppState) =>
    props.data.id
      ? (
          (state.project.flatView[props.data.id] ||
            state.project.treeView[props.data.id]) as PartTypeRow
        )?.materialSummary
      : {}
  )

  return (
    <div className={cn.root}>
      <Typography variant="body2">
        {description ||
          t('project:${props.data.description}', props.data.description)}
      </Typography>
      <MaterialTags selectedTokens={tokens} size="small" />
      <TargetPriceTooltipListItemText
        primary={MoneyString(props.data.mainActivityCostPrice)}
        secondary={t('project:cost-price', 'cost price')}
      />
      <TargetPriceTooltipListItemText
        primary={MoneyString(props.data.surchargeValue)}
        secondary={t('common:surcharge', 'surcharge')}
      />
      <TargetPriceTooltipListItemText
        primary={MoneyString(props.data.discountValue)}
        secondary={t('common:discount')}
      />
      <TargetPriceTooltipListItemText
        primary={MoneyString(props.data.salesPrice)}
        secondary={t('project:price-per-batch')}
      />
    </div>
  )
}
